module.exports = __webpack_public_path__ + "static/bryan-ruef-social-5bc69aaa9eec089899036572f1223147.jpg";